/**
 * This utility function is used to enforce Assignment API POST schema
 *  by formatting `assignmentState`.
 *
 * @param {Object} assignmentState - Assignment object
 *  that will be to be formatted to match POST API schema.
 * @param {Boolean} isDraftAction - A boolean to determine
 *  if we're saving as draft or creating/updating an assignment.
 *
 * @return {Object} that matches Assignment API v3 POST schema.
 */
export const formatAssignmentPayload = (
  assignmentState,
  isDraftAction,
  originalAssignment,
) => {
  if (isDraftAction) {
    return assignmentState;
  }

  // TODO: confirm this date logic or update in ticket handling assignees
  const dateNow = new Date();
  const assignmentGroups = assignmentState.assignment_groups.map(
    (assignmentGroup) => {
      const { group_id: originalGroupId } =
        originalAssignment?.assignment_groups[0] || {};

      return {
        ...assignmentGroup,
        ...(originalGroupId ? { group_id: originalGroupId } : {}),
        date_assigned: dateNow,
      };
    },
  );

  const assignmentClassrooms = assignmentState.assignment_classrooms.map(
    (assignmentClassroom) => {
      // Check if assignment classroom was reset (removed and re-added in the editor)
      // If so, use the original date_assigned of the classroom
      const currentClassroomId =
        assignmentClassroom.classroom_id ?? assignmentClassroom.pk;
      const originalAssignmentClassroom =
        originalAssignment?.assignment_classrooms.find(
          (classroom) => classroom.classroom_id === currentClassroomId,
        );
      return {
        ...assignmentClassroom,
        date_assigned: originalAssignmentClassroom?.date_assigned ?? dateNow,
      };
    },
  );

  return {
    ...assignmentState,
    assignment_groups: assignmentGroups,
    assignment_classrooms: assignmentClassrooms,
    is_draft: false,
  };
};
